import { API, API_POST } from "../../Config";

export const handleAddPolicy = (payload) => {
  const f = new FormData();

  f.append("id", 1);
  f.append("privacy_policy", payload.policy);

  return API_POST(API.addpolicy, f);
};
